import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom';

function ProtectedRoute({children}) {
    const loggedIn = window.sessionStorage.getItem('isLoggedIn');
    const navigate = useNavigate();
    if(loggedIn !==null && loggedIn === 'true'){
        return children;
    } else{
        return <Navigate to="/" replace />
    }
}

export default ProtectedRoute
